// import React, { useState } from "react";
// import {
//   FaArrowUp,
//   FaExchangeAlt,
//   FaCogs,
//   FaUserTie,
//   FaHeadset,
//   FaGraduationCap,
// } from "react-icons/fa";
// import { FiArrowRight } from "react-icons/fi";

// /* ─── Design tokens (inline-style palette) ─── */
// const C = {
//   bg: "#F7F8FC",
//   white: "#FFFFFF",
//   dark: "#0F1923",
//   mid: "#3D4A5C",
//   muted: "#8492A6",
//   accent: "#FF4A3D",
//   border: "rgba(0,0,0,0.07)",
//   borderHover: "rgba(99,102,241,0.35)",
// };

// const GRADIENTS = [
//   "linear-gradient(135deg,#8B5CF6 0%,#D946EF 100%)",
//   "linear-gradient(135deg,#DC2626 0%,#F97316 100%)",
//   "linear-gradient(135deg,#2563EB 0%,#06B6D4 100%)",
//   "linear-gradient(135deg,#6366F1 0%,#4F46E5 100%)",
//   "linear-gradient(135deg,#BE185D 0%,#EC4899 100%)",
//   "linear-gradient(135deg,#D97706 0%,#EAB308 100%)",
// ];

// const GLOW_COLORS = [
//   "rgba(139,92,246,0.18)",
//   "rgba(220,38,38,0.18)",
//   "rgba(37,99,235,0.18)",
//   "rgba(99,102,241,0.18)",
//   "rgba(190,24,93,0.18)",
//   "rgba(217,119,6,0.18)",
// ];

// /* ─── Data ─── */
// const cards = [
//   {
//     title: "Upgrades",
//     description:
//       "Evolve with Infor! Maximize your Syteline, M3 and LN. Upgrade for new features & peak ERP performance with Infor's CloudSuite Industrial experienced partner — it could be one of the last upgrades you'll ever need.",
//     icon: <FaArrowUp size={18} color="#fff" />,
//   },
//   {
//     title: "Migration",
//     description:
//       "Migrate SyteLine, LN, and M3 seamlessly. Data migration is a crucial process for any Infor M3 ERP customer that wants to maximize value — our data experts ensure minimal disruption from legacy to CloudSuite.",
//     icon: <FaExchangeAlt size={18} color="#fff" />,
//   },
//   {
//     title: "Customization",
//     description:
//       "Tailor SyteLine, M3 and LN for your needs. We take a deep dive into Infor CloudSuite Industrial/SyteLine ERP with expert customization that ensures a perfect fit and efficient workflows.",
//     icon: <FaCogs size={18} color="#fff" />,
//   },
//   {
//     title: "Consultation",
//     description:
//       "Our Infor ERP experts provide SyteLine, M3 & LN consultation that optimizes manufacturing and supply chain. We streamline business operations with tailored solutions and proven methodology.",
//     icon: <FaUserTie size={18} color="#fff" />,
//   },
//   {
//     title: "Managed Services",
//     description:
//       "Focus on growth while we manage your Infor applications. Get 24/7 support, proactive upgrades, and continuous optimization — reducing operational costs while boosting agility.",
//     icon: <FaHeadset size={18} color="#fff" />,
//   },
//   {
//     title: "Training",
//     description:
//       "We offer Infor ERP SyteLine, M3 & LN training that boosts user adoption and team efficiency with modern skills to optimize manufacturing and distribution operations.",
//     icon: <FaGraduationCap size={18} color="#fff" />,
//   },
// ];

// /* ─── Service Card ─── */
// const ServiceCard = ({ title, description, icon, gradient, glowColor, index }) => {
//   const [hovered, setHovered] = useState(false);

//   return (
//     <div
//       onMouseEnter={() => setHovered(true)}
//       onMouseLeave={() => setHovered(false)}
//       style={{
//         backgroundColor: C.white,
//         border: `1px solid ${hovered ? C.borderHover : C.border}`,
//         borderRadius: "16px",
//         boxShadow: hovered
//           ? `0 18px 36px -10px ${glowColor}, 0 0 0 1px ${C.borderHover}`
//           : "0 2px 10px rgba(0,0,0,0.04)",
//         transform: hovered ? "translateY(-4px)" : "translateY(0)",
//         transition: "all 0.35s cubic-bezier(0.34,1.56,0.64,1)",
//         overflow: "hidden",
//         position: "relative",
//         display: "flex",
//         flexDirection: "column",
//         height: "100%",
//         padding: "0",
//         animationDelay: `${index * 80}ms`,
//       }}
//       className="group"
//     >
//       {/* Top gradient accent bar */}
//       <div
//         style={{
//           height: "3px",
//           background: gradient,
//           opacity: hovered ? 1 : 0,
//           transition: "opacity 0.3s ease",
//         }}
//       />

//       {/* Glow orb */}
//       <div
//         style={{
//           position: "absolute",
//           top: "-30px",
//           right: "-30px",
//           width: "120px",
//           height: "120px",
//           borderRadius: "50%",
//           background: gradient,
//           opacity: hovered ? 0.07 : 0,
//           filter: "blur(30px)",
//           transition: "opacity 0.5s ease",
//           pointerEvents: "none",
//         }}
//       />

//       <div className="p-5 flex flex-col h-full">
//         {/* Icon */}
//         <div
//           style={{
//             width: "42px",
//             height: "42px",
//             borderRadius: "11px",
//             background: gradient,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             marginBottom: "16px",
//             boxShadow: hovered
//               ? `0 8px 18px -4px ${glowColor}`
//               : "0 4px 10px rgba(0,0,0,0.12)",
//             transform: hovered ? "scale(1.08) rotate(-4deg)" : "scale(1) rotate(0deg)",
//             transition: "all 0.4s cubic-bezier(0.34,1.56,0.64,1)",
//             flexShrink: 0,
//           }}
//         >
//           {icon}
//         </div>

//         {/* Title */}
//         <h3
//           style={{
//             color: C.dark,
//             fontFamily: "'Plus Jakarta Sans', sans-serif",
//             fontWeight: 700,
//             fontSize: "1.02rem",
//             marginBottom: "8px",
//             letterSpacing: "-0.01em",
//             lineHeight: 1.3,
//           }}
//         >
//           {title}
//         </h3>

//         {/* Description */}
//         <p
//           style={{
//             color: C.mid,
//             fontSize: "0.92rem",
//             lineHeight: 1.65,
//             flexGrow: 1,
//             fontFamily: "'Inter', sans-serif",
//             wordBreak: "normal",
//             overflowWrap: "normal",
//             hyphens: "none",
//             whiteSpace: "normal",
//           }}
//         >
//           {description}
//         </p>
//       </div>
//     </div>
//   );
// };

// /* ─── Main component ─── */
// export default function InforServices() {
//   return (
//     <div
//       style={{ backgroundColor: "#001534", fontFamily: "'Inter', sans-serif", minHeight: "100vh" }}
//     >
//       {/* Section */}
//       <section className="w-full py-16 lg:py-20 px-4 sm:px-6 lg:px-8">
//         <div className="max-w-7xl mx-auto">

//           {/* ── Header ── */}
//           <div className="max-w-5xl mb-12 lg:mb-14">
//             {/* Eyebrow */}
//             <div className="flex items-center gap-3 mb-6">
//               <span
//                 className="inline-block w-10 h-[3px] rounded-full"
//                 style={{ backgroundColor: "#ED1B24" }}
//               />
//               <span
//                 className="text-xs font-bold tracking-[0.2em] uppercase"
//                 style={{ color: "#ED1B24" }}
//               >
//                 Our Expertise
//               </span>
//             </div>

//             <h2
//               className="text-3xl sm:text-4xl xl:text-5xl font-bold leading-tight mb-5"
//               style={{ color: "#ffffff" }}
//             >
//               Comprehensive
//               Infor Services
//             </h2>

//             <p
//               className="text-base sm:text-lg leading-relaxed mb-8 font-normal"
//               style={{ color: "#ffffff", wordBreak: "normal", overflowWrap: "normal", hyphens: "none", whiteSpace: "normal" }}
//             >
//               From strategic upgrades to managed support, we deliver end-to-end
//               solutions to maximize the potential of your Infor CloudSuite and ERP
//               investments.
//             </p>
//           </div>

//           {/* ── Cards grid ── */}
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6 items-stretch">
//             {cards.map((card, i) => (
//               <ServiceCard
//                 key={i}
//                 index={i}
//                 title={card.title}
//                 description={card.description}
//                 icon={card.icon}
//                 gradient={GRADIENTS[i]}
//                 glowColor={GLOW_COLORS[i]}
//               />
//             ))}
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }


import React, { useState } from 'react';
import { FaPlus, FaMinus } from 'react-icons/fa';

const cards = [
  {
    title: "Upgrades",
    description: "Evolve with Infor! Maximize your Syteline, M3 and LN. Upgrade for New Features & Peak ERP Performance with Infor's CloudSuite Industrial Experienced Partner! and It Could be One of the Last Upgrades you'll Ever Need.",
    gradient: "linear-gradient(135deg, #8B5CF6 0%, #D946EF 100%)"
  },
  {
    title: "Migration",
    description: "Migrate SyteLine, LN, and M3 Seamlessly. Data Migration is a Crucial Process for Any Infor M3 ERP Customer that Wants to Maximize and Data Experts Ensure Minimal Disruption from Legacy to CloudSuite!.",
     gradient: "linear-gradient(135deg, #DC2626 0%, #F97316 100%)"
  },
  {
    title: "Customization",
    description: "Tailor SyteLine, M3 and LN for your Needs! We Take a Deep Dive into Infor CloudSuite Industrial/Syteline ERP with Expert Customization Ensures Perfect Fit & Efficient Workflows to Extend Functionality.",
    gradient: "linear-gradient(135deg, #2563EB 0%, #06B6D4 100%)"
  },
  {
    title: "Consultation",
    description: "Our Infor ERP with Expert SyteLine, M3 & LN Consultation Optimizes Manufacturing, Supply Chain and We Provide Infor Syteline Support Services to Streamline Business Operations. Get Tailored Solutions Now!.",
    
     gradient: "linear-gradient(135deg, #6366F1 0%, #4F46E5 100%)"
  },
  {
    title: "Managed Services",
    description: "Focus on growth! We Manage your Infor Applications and Provide Maintenance Services too. Get 24/7 Support, Upgrades, & Optimization While Reducing Costs & Boost Agility.",
    gradient: "linear-gradient(135deg, #BE185D 0%, #EC4899 100%)"
  },
  {
    title: "Training",
    description: "We Offer Infor ERP SyteLine, M3 & LN Training Services, Which Boosts User Adoption and Efficiency of your Team with Modern Skills to Optimize Manufacturing and Distribution Operations. Master your System Now!",
    gradient: "linear-gradient(135deg, #D97706 0%, #EAB308 100%)"
  }
];

const ServiceCard = ({ title, description, gradient }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="group relative">
      <div
        style={{
          background: gradient,
          boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
          transition: 'all 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
        className="rounded-lg p-6 overflow-hidden relative cursor-pointer"
        onClick={toggleExpand}
      >
        {/* Content container */}
        <div className="relative z-10 flex justify-between items-center">
          <h3
            style={{
              transition: 'transform 0.8s cubic-bezier(0.4, 0, 0.2, 1)'
            }}
            className="font-bold text-xl text-white mb-6"
          >
            {title}
          </h3>
          {/* Toggle Icon */}
          {isExpanded ? (
            <FaMinus className="text-white" />
          ) : (
            <FaPlus className="text-white" />
          )}
        </div>
        
        {/* Description with fade-in and slide-up animation */}
        <div className={`overflow-hidden transition-all duration-500 ease-in-out ${isExpanded ? 'max-h-[200px]' : 'max-h-0'}`}>
          <p
            className={`text-white/90 transition-opacity duration-500 ease-in-out ${isExpanded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'}`}
            style={{
              transitionDelay: '0.3s',
              lineHeight: '1.6'
            }}
          >
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

const InfoServices = () => {
  return (
    <div className="w-full py-16 lg:py-20 px-4 sm:px-6 lg:px-8 bg-[#ffffff]">
        <div className="max-w-7xl mx-auto">
                {/* ── Header ── */}
          <div className="max-w-7xl mb-12 lg:mb-14">
            {/* Eyebrow */}
            <div className="flex items-center gap-3 mb-6">
              <span
                className="inline-block w-8 h-[3px] rounded-full"
                style={{ backgroundColor: "#ff0000" }}
              />
              <span
                className="text-xs font-bold tracking-[0.2em] uppercase"
                style={{ color: "#ff0000" }}
              >
                Our Expertise
              </span>
            </div>

            <h2
              className="text-3xl sm:text-3xl md:text-4xl font-bold leading-tight mb-5"
              style={{ color: "#000000" }}
            >
              Comprehensive
              Infor Services
            </h2>

            <p
              className="text-base sm:text-lg leading-relaxed mb-8 font-normal"
              style={{ color: "#000000", wordBreak: "normal", overflowWrap: "normal", hyphens: "none", whiteSpace: "normal" }}
            >
              From strategic upgrades to managed support, we deliver end-to-end
              solutions to maximize the potential of your Infor CloudSuite and ERP
              investments.
            </p>
          </div>
      <style jsx global>{`
        @keyframes ripple {
          0% {
            transform: scale(0);
            opacity: 0.7;
          }
          100% {
            transform: scale(3);
            opacity: 0;
          }
        }
        .animate-ripple {
          animation: ripple 2.5s cubic-bezier(0.4, 0, 0.2, 1) infinite;
        }
      `}</style>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {cards.map((card, index) => (
          <ServiceCard
            key={index}
            title={card.title}
            description={card.description}
            gradient={card.gradient}
          />
        ))}
      </div>
    </div>
    </div>
  );
};

export default InfoServices;